export default __webpack_public_path__ + "static/media/p2.985bc496.jpeg";